export enum EnumUbicationNegotiation {
  REPURCHASE = 'REPURCHASE',
  NEIGHBOURS = 'NEIGHBOURS',
  DEPARTMENTAL = 'DEPARTMENTAL',
  INTERNATIONAL = 'INTERNATIONAL',
  OTHER = 'OTHER'
}

export const NAME_UBICATION_NEGOTIATION = {
  [EnumUbicationNegotiation.REPURCHASE]: 'Recompra',
  [EnumUbicationNegotiation.NEIGHBOURS]: 'Aledaños',
  [EnumUbicationNegotiation.DEPARTMENTAL]: 'Departamental',
  [EnumUbicationNegotiation.INTERNATIONAL]: 'Internacional',
  [EnumUbicationNegotiation.OTHER]: 'Otros'
}

export const UBICATION_NEGOTIATION_OPTIONS = [
  {
    label: NAME_UBICATION_NEGOTIATION[EnumUbicationNegotiation.REPURCHASE],
    value: EnumUbicationNegotiation.REPURCHASE
  },
  {
    label: NAME_UBICATION_NEGOTIATION[EnumUbicationNegotiation.NEIGHBOURS],
    value: EnumUbicationNegotiation.NEIGHBOURS
  },
  {
    label: NAME_UBICATION_NEGOTIATION[EnumUbicationNegotiation.DEPARTMENTAL],
    value: EnumUbicationNegotiation.DEPARTMENTAL
  },
  {
    label: NAME_UBICATION_NEGOTIATION[EnumUbicationNegotiation.INTERNATIONAL],
    value: EnumUbicationNegotiation.INTERNATIONAL
  },
  {
    label: NAME_UBICATION_NEGOTIATION[EnumUbicationNegotiation.OTHER],
    value: EnumUbicationNegotiation.OTHER
  }
]
